import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Checkbox } from "./ui/checkbox";

const NONE = "__none__";
const label = (c) => `${c.letter} · ${c.label || "(no header)"}`;

export function ColumnPicker({ columns, value, onChange, multi, testId, disabled }) {
  if (multi) {
    const sel = value || [];
    const toggle = (l) => onChange(sel.includes(l) ? sel.filter((x) => x !== l) : [...sel, l]);
    return (
      <Popover>
        <PopoverTrigger asChild disabled={disabled}>
          <button data-testid={testId} className="w-full h-9 px-3 rounded-md border border-input bg-[#0B0F17] font-mono text-xs text-left truncate disabled:opacity-50">
            {sel.length ? sel.join(", ") : "— not mapped —"}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-72 p-0 bg-[#131B2E] border-slate-800">
          <div className="max-h-72 overflow-y-auto p-2">
            {[...columns.filter((c) => sel.includes(c.letter)), ...columns.filter((c) => !sel.includes(c.letter))].map((c) => (
              <label key={c.letter} className="flex items-center gap-2 px-2 py-1.5 rounded hover:bg-slate-800 cursor-pointer text-xs font-mono">
                <Checkbox checked={sel.includes(c.letter)} onCheckedChange={() => toggle(c.letter)} data-testid={`${testId}-${c.letter}`} />
                <span className="truncate">{label(c)}</span>
              </label>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    );
  }
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)} disabled={disabled}>
      <SelectTrigger data-testid={testId} className="bg-[#0B0F17] font-mono text-xs"><SelectValue /></SelectTrigger>
      <SelectContent className="max-h-72">
        <SelectItem value={NONE}>— not mapped —</SelectItem>
        {columns.map((c) => <SelectItem key={c.letter} value={c.letter}>{label(c)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
